export const USER_MAIL = 'USER_MAIL';
export const USER_MOB = 'USER_MOB';
